import React, { useEffect, useState } from 'react'
import { DatePicker, TimePicker } from 'antd';
import moment from 'moment';
import "../scheduledetails/style/scheduledetails.css";
import "../requestforvolunteeringservices.css";
import "../../../careprovider/components/formadditionaldetails/formadditionaldetails.css";
import { disabledDate, disabledFutureDate } from '../../../careprovider/visits/utils';
import { convertDateToSODTimestamp, convertTimeToTimestamp, getDateFormat, mergeDateAndTime } from '../../../../utils/dateutils';

const EditDeliveryComponent = ({ initialDeliveryData, onDataChangeCallback, setSubmitButtonVisibility }) => {
  const [initialData, setInitialData] = useState(initialDeliveryData);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const statusList = ["Filled", "Completed","Edited","Rejected"]

  useEffect(() => {
    setInitialData(initialDeliveryData);
  }, [initialDeliveryData?.patientIdentifier])

  useEffect(() => {
    const initialDeliveryDate = moment(initialData?.deliveryDate || Date.now()).format(getDateFormat());
    if (initialDeliveryDate) {
      setDeliveryDate(initialDeliveryDate);
    }

    const initialStartTime = moment(initialData?.startTime)?.format();
    if (initialStartTime) {
      setStartTime(initialStartTime);
    }

    const initialEndTime = moment(initialData?.endTime)?.format();
    if (initialEndTime) {
      setEndTime(initialEndTime);
    }

    onDataChangeCallback({
      ...initialData,
      deliveryDate: convertDateToSODTimestamp(initialDeliveryDate),
      startTime: convertTimeToTimestamp(initialStartTime),
      endTime: convertTimeToTimestamp(initialEndTime),
    });
  }, [initialData]);

  const setStartDate = (date) => {
    if (date !== null) {
      const selectedDate = moment(date._d).endOf("day").format();
      setDeliveryDate(moment(selectedDate).format(getDateFormat()));
      onDataChangeCallback(prevValue => ({ ...prevValue, deliveryDate: convertDateToSODTimestamp(selectedDate) }));
    }
  }

  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  const disableEndTime = (date) => {
    const selectedDate = moment(startTime);
    return {
      disabledHours: () => range(0, 24).splice(0, selectedDate.hour()),
      disabledMinutes: (selectedHour) => {
        if (selectedHour === selectedDate.hour()) {
          return range(0, 60).splice(0, selectedDate.minute() + 15);
        }
        return [];
      },
    }
  }

  const handleSetStartTime = (time, timeString) => {
    let dateAndTime;
    if (time !== null) {
      const selectedTime = time._d && moment(time._d).format();
      dateAndTime = mergeDateAndTime(deliveryDate, selectedTime);
      setStartTime(dateAndTime);
    }
    else {
      setStartTime(null);
    }
    onDataChangeCallback(prevValue => ({ ...prevValue, startTime: dateAndTime && convertTimeToTimestamp(dateAndTime) }));
  }

  const handleSetEndTime = (time, timeString) => {
    let dateAndTime;
    if (time !== null) {
      const selectedTime = time._d && moment(time._d).format();
      dateAndTime = mergeDateAndTime(deliveryDate, selectedTime);
      setEndTime(dateAndTime);
      }
    else {
      setEndTime(null);
    }
    onDataChangeCallback(prevValue => ({ ...prevValue, endTime: dateAndTime && convertTimeToTimestamp(dateAndTime) }));
  }

  useEffect(() => {
    if (!deliveryDate || !startTime || !endTime || (initialData?.deliveryDate === convertDateToSODTimestamp(deliveryDate) &&
      initialData?.endTime === convertTimeToTimestamp(endTime) &&
      initialData?.startTime === convertTimeToTimestamp(startTime))) {
      setSubmitButtonVisibility(true);
    } else {
      setSubmitButtonVisibility(false);
    }
  }, [deliveryDate, startTime, endTime]);

  return (
    <div className='main-container'>
      <div className='container-header'>
        <span>Edit Visit</span>
      </div>
      <div className='container-content'>
      <div className='section-three'>
          <div className='section-three-subsection'>
            <span className='required-mark-label'>Visit Start Date</span>
            <DatePicker disabledDate={statusList.includes(initialData?.deliveryStatus) ? disabledFutureDate : disabledDate} value={moment(deliveryDate, getDateFormat())} placeholder={getDateFormat()} format={getDateFormat()} style={{ width: "100%" }} onChange={setStartDate} />
          </div>
        </div>
        <div className='time-selection-container'>
          <div className='time-selection'>
            <span className='required-mark-label'>Start Time</span>
            <TimePicker value={startTime ? moment(startTime) : null} placeholder="hh:mm" format="HH:mm" minuteStep={15} style={{ width: "100%" }} onChange={handleSetStartTime} onSelect={handleSetStartTime} popupClassName='time-picker-custom-class'/>
          </div>
          <div className='time-selection'>
            <span className='required-mark-label'>End Time</span>
            <TimePicker value={endTime ? moment(endTime) : null} disabledTime={disableEndTime} placeholder="hh:mm" format="HH:mm" minuteStep={15} style={{ width: "100%" }} onChange={handleSetEndTime} onSelect={handleSetEndTime} popupClassName='time-picker-custom-class'/>
            <p className='info-text-normal'>* End time should be greater than start time</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditDeliveryComponent;